import { env } from "../env";

export const environments = ["development", "production", "staging"] as const;

export type Environment = (typeof environments)[number];

export default function useEnvironment() {
  return env.VITE_APP_ENVIRONMENT;
}
